import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Modal } from "react-bootstrap";

interface ModalHeaderWithActionsProps {
    title: string;
    onClose: () => void;
    onSubmit: () => void;
    canSubmit: boolean;
    isInEditMode?: boolean;
}

const ModalHeaderWithActions: React.FC<ModalHeaderWithActionsProps> = ({
    title,
    onClose,
    onSubmit,
    canSubmit,
    isInEditMode = true,
}) => {
    return (
        <Modal.Header>
            <Modal.Title as='div' className="w-100 me-5">{title}</Modal.Title>  
            <Col className="me-2">
                <button
                    type="button"
                    className="edit-button big circular-button visual-selection-aid"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </Col>
            {isInEditMode && (
                <Col>
                    <button
                        type="button"
                        className={`edit-button big circular-button visual-selection-aid ${!canSubmit ? "disabled" : ""}`}
                        onClick={canSubmit ? onSubmit : undefined}
                        aria-label="Submit"
                        aria-disabled={!canSubmit}
                        tabIndex={canSubmit ? 0 : -1}
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </button>
                </Col>)}
        </Modal.Header>
    );
};

export default ModalHeaderWithActions;
